export const Style = ({ colors = [] }) => <g></g>

export const Back = ({ colors = [] }) => <g></g>

Style.Back = Back
